import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import PropertyBalancesTable from "./propertyBalancesTable/PropertyBalancesTable";
import PageWrapper, { PageCreateButton } from "app/modules/shared/PageWrapper";
import { ClientPortalWebNarratives } from "cpl-react-common/components/Enums/ClientPortalWebNarratives";

const AccountsPage: React.FC = () => {
  return (
    <CPLAnalytics pageName="Client Portal Accounts">
      <PageWrapper
        title="Accounts"
        webNarrativeID={ClientPortalWebNarratives.Accounts}
        data-test-id="accounts-page__back-button"
        extraElements={
          <PageCreateButton to={`/AddAccount/`} text="Add Account" data-test-id="accounts-page__add-account-link" />
        }
      >
        <PropertyBalancesTable />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default AccountsPage;
